
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import BookListPop from '../BookListPop/index.vue'
import Title from '../Title/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    Title,
    BookListPop
  }
})
export default class Book extends Vue {
  @Ref('bookListPop')
  bookListPop: {
    open: () => void
    hide: () => void
  }

  get PageStore() {
    return this.$store.$myV2.Classroom
  }

  openBookListPop() {
    this.bookListPop.open()
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
